<template>
  <div class="cont">
    <!-- <van-swipe class="my-swipe" :autoplay="4000" indicator-color="white">
      <van-swipe-item v-for="son in CarouselSlideList" v-bind:key="son.ID">
        <img class="banner-image" :src="son.FilePath" alt="" />
        <div class="banner-text-box" v-bind:class="[son.PicName]">
          <div>{{ son.Headline }}</div>
          <p>{{ son.Englishtitle }}</p>
          <h3>{{ son.Subhead }}</h3>
        </div>
      </van-swipe-item>
    </van-swipe> -->

    <div>
      <div style="">
        <div>
          <div style="position: relative; margin: 12px">
            <img
              style="width: 100%"
              src="@/assets/img/show-house.jpg"
              alt=""
              @click="goNext('yszt')"
            />
            <!-- @click="goPage('http://www.coalgeocloud.com:8081/',1)" -->
            <div class="home-yszt-tips" @click.stop>
              陕煤地质【云上展厅】，打破空间束缚，畅享虚拟现实。
            </div>
            <div
              style="
                position: absolute;
                top: 0;
                right: 0;
                color: #fff;
                text-align: right;
                margin-bottom: 2px;
                line-height: 2;
                font-size: 12px;
              "
              @click.stop
            >
              <!-- href="http://www.coalgeocloud.com:8081/" -->
              <span
                @click="goNext('yszt')"
                style="
                  display: inline-block;
                  padding: 0 8px;
                  background: rgba(0, 0, 0, 0.2);
                  cursor: default;
                  color: #fff;
                "
                >查看云上展厅 ></span
              >
            </div>
          </div>
          <div style="padding: 12px; background: #f2f2f2">
            <div class="news-tab-nav">
              <span
                :class="[nIndex == 0 ? 'active' : '']"
                @mouseover="nIndex = 0"
                >新闻资讯</span
              >
              <span
                :class="[nIndex == 1 ? 'active' : '']"
                @mouseover="nIndex = 1"
                >供求信息</span
              >
              <span
                :class="[nIndex == 2 ? 'active' : '']"
                @mouseover="nIndex = 2"
                >知识共享</span
              >
              <span
                :class="[nIndex == 3 ? 'active' : '']"
                @mouseover="nIndex = 3"
                >知识库</span
              >
            </div>
            <div class="home-news-list" v-show="nIndex == 0">
              <template v-for="(son, index) in tableNewData">
                <div v-if="index < 3" class="home-news-item" :key="son.ID">
                  <!-- <router-link
                    target="_self"
                    :to="{
                      path: '/IndustryDynamic_detail_h5',
                      query: { id: son.ID },
                    }"
                    style="display: flex"
                  > -->
                  <div @click="goNext('xwzx', son.ID)" class="flex1">
                    <div class="home-news-date">
                      <span>{{ FormatDate(son.CreateTime, "D") }}</span
                      >{{ FormatDate(son.CreateTime, "NY") }}
                    </div>
                    <div class="home-news-right">
                      <div class="home-news-content">
                        <h6>{{ son.NewsTitle }}</h6>
                        <p>
                          {{ son.NewsContent.replace(/<[^>]+>/g, "") }}
                        </p>
                      </div>
                      <div class="home-news-more">更多</div>
                    </div>
                  </div>
                  <!-- </router-link> -->
                </div>
              </template>
            </div>

            <div class="home-news-list" v-show="nIndex == 1">
              <template v-for="(son, index) in tableNeedData">
                <div v-if="index < 3" class="home-news-item" :key="son.ID">
                  <!-- <router-link
                    target="_self"
                    :to="{
                      path: '/TradeLeads_detail_h5',
                      query: { id: son.ID },
                    }"
                    style="display: flex"
                  > -->
                  <div @click="goNext('gqxx', son.ID)" class="flex1">
                    <div class="home-news-date">
                      <span>{{ FormatDate(son.CreateTime, "D") }}</span
                      >{{ FormatDate(son.CreateTime, "NY") }}
                    </div>
                    <div class="home-news-right">
                      <div class="home-news-content">
                        <h6>{{ son.Title }}</h6>
                        <p>
                          {{ son.FbContext }}
                        </p>
                      </div>
                      <div class="home-news-more">更多</div>
                    </div>
                  </div>
                  <!-- </router-link> -->
                </div>
              </template>
            </div>

            <div class="home-news-list" v-show="nIndex == 2">
              <template v-for="(son, index) in tableKnowledgeData">
                <div v-if="index < 3" class="home-news-item" :key="son.ID">
                  <!-- <router-link
                    target="_self"
                    :to="{
                      path: '/knowledge_h5',
                    }"
                    style="display: flex"
                  > -->
                  <div @click="goNext('zsgx')" class="flex1">
                    <div class="home-news-date">
                      <span>{{ FormatDate(son.CreateTime, "D") }}</span
                      >{{ FormatDate(son.CreateTime, "NY") }}
                    </div>
                    <div class="home-news-right">
                      <div class="home-news-content">
                        <h6>{{ son.FileName }}</h6>
                        <p>
                          <span style="display: inline-block; width: 50%"
                            >类型：{{ shownewFileKind(son.FileKind) }}</span
                          >
                          <span>阅读量：{{ son.Readingvolume }}</span>
                        </p>
                      </div>
                      <div class="home-news-more">预览</div>
                    </div>
                  </div>
                  <!-- </router-link> -->
                </div>
              </template>
            </div>
            <div class="home-news-list" v-show="nIndex == 3">
              <div style="position: relative">
                <img style="width: 100%" src="@/assets/img/zsk1.png" alt="" />
                <div
                  style="
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: rgba(0, 0, 0, 0.3);
                  "
                >
                  <a
                    href="#"
                    target="_self"
                    style="
                      color: #fff;
                      text-decoration: underline !important;
                      font-size: 5.6vw;
                    "
                    >知识库 >></a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="video-banner">
      <div style="padding: 0 12px">
        <div>
          <div style="position: relative">
            <div class="home-video-center">
              <h6>科普视频</h6>
              <!-- $router.push({ path: '/science_h5', query: { tab: 'second' } }) -->
              <span @click="goNext('kpsp')">+更多</span>
            </div>
            <div style="position: relative">
              <!--q将http换成https -->
              <video
                ref="video"
                src="https://www.coalgeocloud.com:31006/Upload/933ecdd758ad4ab28bcd6b75c41fcc54/煤炭的形成与利用.mp4"
                controls="controls"
                style="width: 100%"
              >
                您的浏览器不支持视频播放
              </video>
              <div
                style="
                  position: absolute;
                  width: 100%;
                  height: 100%;
                  left: 0;
                  top: 0;
                "
                v-if="playBtnShow"
                @click="toggleVideoAction"
              >
                <div
                  style="
                    position: absolute;
                    color: #fff;
                    opacity: 0.5;
                    font-size: 5vw;
                    top: 50%;
                    left: 50%;
                    margin-top: -5vw;
                    margin-left: -5vw;
                    width: 10vw;
                    height: 10vw;
                    line-height: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    border: 1vw solid #fff;
                  "
                >
                  <i class="fa fa-play" style="margin-left: 1vw"></i>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-bottom: 12px">
            <div class="home-video-center">
              <h6>科普大家</h6>
              <span @click="goNext('kpdj')">+更多</span>
              <!-- <span @click="$router.push({ path: '/science_h5' })">+更多</span> -->
            </div>
            <div style="background: #f2f2f2">
              <van-swipe
                class="my-swipe"
                :autoplay="2000"
                indicator-color="white"
              >
                <van-swipe-item v-for="item in tableSienceData" :key="item.ID">
                  <div>
                    <div
                      style="
                        margin: 12px 20vw;
                        box-sizing: border-box;
                        height: 80vw;
                        border-radius: 100%;
                        overflow: hidden;
                      "
                    >
                      <!-- @click="
                          goPage({
                            name: 'sciencedetail_h5',
                            query: { id: item.ID },
                          },2)
                        " -->
                      <img
                        @click="goNext('kpdj2', item.ID)"
                        :src="item.VideoPath"
                        style="width: 100%; min-height: 100%"
                      />
                    </div>
                    <!-- <router-link
                        target="_self"
                        :to="{ name: 'sciencedetail_h5', query: { id: item.ID } }"
                        >{{ item.PeopleName }}</router-link
                      > -->
                    <div
                      class="home-video-people"
                      @click="goNext('kpdj2', item.ID)"
                    >
                      <span>{{ item.PeopleName }}</span>
                    </div>
                  </div>
                </van-swipe-item>
              </van-swipe>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ====== 实用工具 Start ====== -->
    <div class="services">
      <div class="pubTit">
        <h2>实用工具</h2>
        <p>Utilities</p>
        <i></i>
      </div>

      <van-swipe class="my-swipe" :autoplay="4000" indicator-color="gray">
        <van-swipe-item v-for="(imgList, index) in UtilitiesList" :key="index">
          <div class="item box-shadow" style="border-radius: 0">
            <!-- <router-link
              :to="{ path: '/' + imgList.Href }"
              title="Web Development"
            > -->
            <div class="service_icon">
              <img class="top-img" :src="imgList.Src" :alt="imgList.Title" />
            </div>
            <div class="service_detail">
              <h5>
                {{ imgList.Title }}
              </h5>
              <p>
                {{ imgList.Info }}
              </p>
            </div>
            <!-- </router-link> -->
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- ====== 实用工具 End ====== -->
    <!-- ====== HPC Start ====== -->
    <div class="computer">
      <div>
        <div class="manageDom">
          <div class="heading" style="padding-left: 12px">
            <h2 class="home-session-title">科研项目管理</h2>
            <div class="home-session-title-en">
              Management of scientific research projects
            </div>
            <div style="display: flex; align-items: center">
              <div style="flex: 1; overflow: hidden; margin-right: 12px">
                <p v-for="(item, index) in manageList" :key="index">
                  <!-- @click="$router.push(item.path)" -->
                  <a
                    class="button--aylen"
                    :style="{ '--styleColor': portalStyle }"
                    >{{ item.title }}</a
                  >
                </p>
              </div>
              <div style="flex: 1; overflow: hidden">
                <img src="@/assets/img/HPC.png" style="width: 100%" />
              </div>
            </div>
          </div>
        </div>
        <div>
          <div>
            <div style="padding: 0 12px">
              <div>
                <div class="heading">
                  <h2 class="home-session-title">工程项目管理</h2>
                  <div class="home-session-title-en">
                    Geological exploration project management
                  </div>
                </div>
                <div style="display: flex; flex-wrap: wrap">
                  <p
                    v-for="(item, index) in surveyList"
                    :key="index"
                    class="surveyDom"
                  >
                    <!-- @click="$router.push(item.path)" -->
                    <a
                      class="button--aylen"
                      :style="{ '--styleColor': portalStyle }"
                      >{{ item.title }}</a
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <span class="ball_a" style="margin: 0; padding: 0"></span>
        <span class="ball_b" style="margin: 0; padding: 0"></span>
        <span class="ball_c" style="margin: 0; padding: 0"></span>
        <span class="ball_d" style="margin: 0; padding: 0"></span>
      </div>
    </div>

    <!-- ====== HPC End ====== -->

    <!-- ====== News Start ====== -->
    <!-- <div class="news" style="padding:30px 0;margin:0;">
      <div class="pubTit">
        <h2>行业资讯</h2>
        <p>News</p>
        <i></i>
      </div>
      <router-link to="/IndustryDynamic_list">        
         <img src="@/assets/img/news-bg.jpg" style="width:100%;" />
      </router-link>
      <div class="xwcb" v-for="son in tableNewData" v-bind:key="son.ID">
        <router-link
          target="_blank"
          :to="{
            path: '/IndustryDynamic_detail',
            query: { id: son.ID }
          }"
        >
          <div class="xwcb_a">
            <span>{{ FormatDate(son.CreateTime, "D") }}</span
            >{{ FormatDate(son.CreateTime, "NY") }}
          </div>
          <div class="xwcb_b">
            <h6>{{ son.NewsTitle }}</h6>
            <p>
              {{ son.NewsContent.replace(/<[^>]+>/g, "") }}
            </p>
          </div>
          <div class="xwcb_c">
            <img src="@/assets/img/d10.png" alt="" />
            <img src="@/assets/img/d10-1.png" alt="" />
          </div>
          <div class="clearfix"></div>
        </router-link>
      </div>
    </div> -->

    <!-- ====== News End ====== -->

    <div>
      <div>
        <!-- 左侧 -->
        <div style="padding: 12px">
          <div>
            <h2 class="home-session-title">地质特征在线查询</h2>
            <div class="home-session-title-en">GEOLOGICAL INQUIRY</div>
            <div class="home-session-title-dec">
              可为您提供快速定位查询区域，欢迎通过本平台共享您的相关知识
            </div>
          </div>
          <div class="dztzcx-box">
            <div class="dztzcx-box-inner">
              <img
                class="dztzcx-image1"
                src="@/assets/img/home_service_center.png"
                alt=""
              />
              <img
                class="dztzcx-image2"
                src="@/assets/img/home_service_center2.png"
                alt=""
              />
              <ul class="flex-item-ul">
                <li>
                  <div>
                    <!-- <router-link
                      target="_blank"
                      :to="{
                        path: '/GeologicalQuery_h5',
                        query: { typename: '区域地质特征' },
                      }"
                    > -->
                    <i class="iconfont iconfabu"></i>
                    <div class="flex-item-des">
                      <p>区域地质特征</p>
                      <p>区域地层、区域构造、区域地震</p>
                    </div>
                    <!-- </router-link> -->
                  </div>
                </li>
                <li>
                  <div>
                    <i class="iconfont iconshuxiebi"></i>
                    <div class="flex-item-des">
                      <p>区域水文地质特征</p>
                      <p>
                        地表水系、区域含（隔）水层水文地质特征、地下水补、径、排条件、区域地下水水化学特征
                      </p>
                    </div>
                  </div>
                </li>
                <li>
                  <div>
                    <i class="iconfont icon71"></i>
                    <div class="flex-item-des">
                      <p>环境地质特征</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div>
                    <i class="iconfont iconshouji"></i>
                    <div class="flex-item-des">
                      <p>灾害地质特征</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div>
                    <i class="iconfont iconxiongzhang"></i>
                    <div class="flex-item-des">
                      <p>自然地理</p>
                      <p>交通、地形地貌、地形地貌、人文经济</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <p style="text-align: center">
            <!-- <router-link
              to="/GeologicalQuery_h5"
              class="btn btn-primary mlr-5 get-more-info-btn"
              >了解更多
            </router-link> -->
            <span
              @click="goNext('ljgd')"
              class="btn btn-primary mlr-5 get-more-info-btn"
              >了解更多
            </span>
          </p>
        </div>
        <!-- 右侧 -->
        <div class="item-flex-right">
          <div style="padding-bottom: 0">
            <h2 class="home-session-title">地质报告辅助编制</h2>
            <div class="home-session-title-en">
              INTELLIGENT COMPILATION OF GEOLOGICAL REPORT
            </div>
            <div class="home-session-title-dec">
              地质报告的数据、资料具有多源、多类、多量、多主题的特点，在地质预查、普查、详查、勘探全过程中地质数据资料又具有动态更新的特征。
              因此，地质报告的编制要使用复杂的地质基础资料，而且其重复利用率较高，在使用过程中又极易出现数据资料的丢失、重叠。
              传统的手工处理地质资料方式和地质报告的编制模式已难以适应形势发展的需求。
              实现地质资料的输入、管理、处理以及表格、文字的自动化生成，地质报告的智能化编制已成为地质行业的当前需求和未来需要。
              通过煤炭地质云平台地质报告智能编制系统的应用，实现地质报告编制过程的智能化，缩短地质报告编制周期，提高报告的编制质量，具有明显的社会技术经济效益。
            </div>
          </div>
          <div class="item-flex-right-content">
            <div
              class="item-flex-right-btn"
              v-for="(i, k) in ICOGRList"
              :key="k"
            >
              <a
                @click="openNewWeb(i.title)"
                class="button button--aylen"
                :style="{ '--styleColor': portalStyle }"
              >
                <p>
                  <i
                    class="iconfont"
                    :class="i.icon"
                    :style="{ color: portalStyle }"
                  ></i>
                </p>
                <p>{{ i.title }}</p>
              </a>
            </div>
          </div>
          <p style="text-align: center; margin-top: 12px">
            <el-button
              type="primary"
              class="btn btn-primary mlr-5 get-more-info-btn"
              >编制报告</el-button
            >
            <!-- <router-link
              to="/GeologicalReport/AuxiliaryEstablishmentList"
              class="btn btn-primary mlr-5 get-more-info-btn"
              >编制报告
            </router-link> -->
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getNewList,
  getCarouselSlideList,
  getUtilitiesList,
  getGeologicalfeatureList,
} from "@/api/Index";
import { PopularsciencePepole } from "@/api/science";
import { getXQFBList } from "@/api/TradeLeads_api";
import { getList } from "@/api/Knowledgeapi";
import "@/assets/js/jquery-2.1.1.min.js";
import "@/assets/css/mycss/style.css";
import "@/assets/css/mycss/default.css";
import "@/assets/font/iconfont.css";
import "@/assets/css/mycss/index.css";
import "@/assets/css/mycss/owl.carousel.min.css";
import vueSeamlessScroll from "vue-seamless-scroll";

export default {
  name: "Example03Basic",
  data() {
    return {
      portalStyle: "",
    };
  },
  components: {
    vueSeamlessScroll,
  },
  created() {
    console.log(this.$store.getters.sitestyle, "this.$store.getters.sitestyle");
    this.portalStyle = "";
    if (this.$store.getters.sitestyle == "red") {
      this.portalStyle = "#be4949";
    } else if (this.$store.getters.sitestyle == "gray") {
      this.portalStyle = "gray";
    } else {
      this.portalStyle = "#007bff";
    }
  },
  mounted() {
    // debugger;

    this.loadNewData();
    this.loadCarouselSlide();
    this.loadUtilities();
    this.loadGeologicalfeature();
  },
  data() {
    return {
      playBtnShow: true,
      nIndex: 0,
      caption: "caption",
      listData: [1, 2, 3, 4, 5, 6],
      tableNewData: [],
      tableNeedData: [],
      tableSienceData: [],
      tableKnowledgeData: [],
      classOption: {
        limitMoveNum: 2,
        switchSingleStep: 140,
        direction: 3,
      },
      CarouselSlideList: [],
      UtilitiesList: [],
      GeologicalfeatureList: [],
      ICOGRList: [
        {
          title: "地质",
          icon: "icondizhi1",
        },
        {
          title: "水文地质",
          icon: "iconshuiwen",
        },
        {
          title: "工程地质",
          icon: "icongongcheng",
        },
        {
          title: "环境地质",
          icon: "iconhuanjing",
        },
        {
          title: "灾害地质",
          icon: "iconzaihai",
        },
        {
          title: "煤质",
          icon: "icon184meizhifenxi",
        },
        {
          title: "采样测试",
          icon: "iconcaiyangji",
        },
        {
          title: "测量",
          icon: "iconceliang",
        },
        {
          title: "地球物理测井",
          icon: "icondiqiu",
        },
        {
          title: "地震勘探",
          icon: "icondizhen",
        },
        {
          title: "电法",
          icon: "icondibandianfa",
        },
        {
          title: "磁法",
          icon: "iconcili",
        },
        {
          title: "钻探",
          icon: "iconzuantanfa",
        },
        {
          title: "槽探",
          icon: "iconcaoyekongzhixiangmuguanli",
        },
        {
          title: "坑探",
          icon: "iconkengtangongcheng",
        },
      ],
      manageList: [
        {
          title: "申报管理",
          path: "/ProjectInitiation",
        },
        {
          title: "合同管理",
          path: "/ContractList",
        },
        {
          title: "项目进展",
          path: "/Implementation",
        },
        {
          title: "项目验收",
          path: "/ProjectAcceptance",
        },
      ],
      surveyList: [
        {
          title: "项目创建",
          path: "/GCProjectManagement",
        },
        {
          title: "项目技术管理",
          path: "/ProjectTechnology",
        },
        // {
        //   title: "质量管理",
        //   path: '/ProjectInitiation'
        // },
        {
          title: "项目技术管理视图",
          path: "/ProjectTeChnicalViewList",
        },
        {
          title: "项目统计",
          path: "/ProjectWeeklyReport",
        },
        {
          title: "项目工作周报上报",
          path: "/ProjectWorkReport",
        },
        {
          title: "项目验收",
          path: "/ProjectCheckAcceptanceList",
        },
        {
          title: "项目评审",
          path: "/ProjectReviewList",
        },
        {
          title: "项目管理驾驶舱",
          path: "/ProjectOneDrawing",
        },
      ],
    };
  },
  methods: {
    goNext(i, parmas) {
      console.log("aaa");
      // window.open('https://www.coalgeocloud.com:31003/TradeLeads_detail_h5?id='+parmas, '_self');
      // switch (i) {
      //   case "yszt":
      //     window.android.jsCallMethod(
      //       "jump",
      //       "http://www.coalgeocloud.com:8081/"
      //     );
      //     break; //云上展厅
      //   case "xwzx":
      //     this.$router.push({
      //       path: "/IndustryDynamic_detail_h5",
      //       query: { id: parmas },
      //     });
      //     break; //新闻资讯
      //   case "gqxx":
      //     this.$router.push({
      //       path: "/TradeLeads_detail_h5",
      //       query: { id: parmas },
      //     });
      //     break; //供求信息
      //   case "zsgx":
      //     this.$router.push({ path: "/knowledge_h5" });
      //     break; //知识共享
      //   case "kpsp":
      //     this.$router.push({ path: "/science_h5?tab=second" });
      //     break; //科普视频
      //   case "kpdj":
      //     this.$router.push({ path: "/science_h5" });
      //     break; //科普大家
      //   case "kpdj2":
      //     this.$router.push({
      //       path: "/sciencedetail_h5",
      //       query: { id: parmas },
      //     });
      //     break; //科普大家
      //   case "ljgd":
      //     this.$router.push({ path: "/GeologicalQuery_h5" });
      //     break; //地址查询
      //   default:
      //     break;
      // }
      // return;
      switch (i) {
        case "yszt":
          window.android.jsCallMethod(
            "jump",
            "http://www.coalgeocloud.com:8081/"
          );
          break; //云上展厅
        case "xwzx":
          window.android.jsCallMethod(
            "jump",
            "https://www.coalgeocloud.com/IndustryDynamic_detail_h5?id=" +
              parmas
          );
          break; //新闻资讯
         case "gqxx":
              window.android.jsCallMethod(
            "jump",
            "https://www.coalgeocloud.com/TradeLeads_detail_h5?id=" +
              parmas
          );
          // this.$router.push({
          //   path: "/TradeLeads_detail_h5",
          //   query: { id: parmas },
          // });
          break; //供求信息
        case "zsgx":
          window.android.jsCallMethod(
            "jump",
            "https://www.coalgeocloud.com/knowledge_h5"
          );
          break; //知识共享
        case "kpsp":
          window.android.jsCallMethod(
            "jump",
            "https://www.coalgeocloud.com/science_h5?tab=second"
          );
          break; //科普视频
        case "kpdj":
          window.android.jsCallMethod(
            "jump",
            "https://www.coalgeocloud.com/science_h5"
          );
          break; //科普大家
        case "kpdj2":
          window.android.jsCallMethod(
            "jump",
            "https://www.coalgeocloud.com/sciencedetail_h5?id=" + parmas
          );
          break; //科普大家
        case "ljgd":
          window.android.jsCallMethod(
            "jump",
            "https://www.coalgeocloud.com/GeologicalQuery_h5"
          );
          break; //地址查询
        default:
          break;
      }
    },
    goPage(route, flag) {
      let href;
      if (flag == 1) {
        href = route;
        window.open(href, "_self");
      } else {
        let { href } = this.$router.resolve(route);
        window.open(href, "_self");
      }
    },
    toggleVideoAction() {
      if (this.playBtnShow) {
        this.playBtnShow = false;
        console.log(this.playBtnShow);
        let v = this.$refs.video;
        console.log(v);
        v.play();
      }
    },
    shownewFileKind(ogStr) {
      let newStrHtml = "";
      let appnewstr = "";
      if (ogStr == "1") {
        appnewstr = "文档";
      }
      if (ogStr == "2") {
        appnewstr = "视频";
      }
      if (ogStr == "3") {
        appnewstr = "音频";
      }
      if (appnewstr != "") {
        newStrHtml = `${appnewstr}`;
      }
      return newStrHtml;
    },
    initimg() {
      let newDataList = [];
      let current = 0;
      if (this.UtilitiesList && this.UtilitiesList.length > 0) {
        for (let i = 0; i <= this.UtilitiesList.length - 1; i++) {
          if (i % 4 !== 0 || i === 0) {
            if (!newDataList[current]) {
              newDataList.push([this.UtilitiesList[i]]);
            } else {
              newDataList[current].push(this.UtilitiesList[i]);
            }
          } else {
            current++;
            newDataList.push([this.UtilitiesList[i]]);
          }
        }
      }
      if (newDataList.length > 0) {
        var j = newDataList.length - 1;

        if (newDataList[j].length < 4) {
          for (let k = 0; k <= this.UtilitiesList.length; k++) {
            if (newDataList[j].length < 4) {
              newDataList[j].push(this.UtilitiesList[k]);
            }
          }
        }
      }

      this.UtilitiesList = [...newDataList];
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    loadUtilities() {
      getUtilitiesList().then((res) => {
        if (res.Code === 200) {
          this.UtilitiesList = res.Data;
          // this.initimg();
          // this.$refs.seamlessScroll.reset();
        }
      });
    },
    loadGeologicalfeature() {
      getGeologicalfeatureList().then((res) => {
        if (res.Code === 200) {
          this.GeologicalfeatureList = res.Data;
        }
      });
    },
    loadCarouselSlide() {
      getCarouselSlideList().then((res) => {
        if (res.Code === 200) {
          this.CarouselSlideList = res.Data;
        }
      });
    },
    loadNewData() {
      getNewList({}).then((res) => {
        if (res.Code === 200) {
          this.tableNewData = res.Data;
        } else {
          this.tableNewData = [];
        }
      });

      getXQFBList({
        PageIndex: 1,
        PageSize: 7,
        total: 0,
      }).then((res) => {
        if (res.Code === 200) {
          this.tableNeedData = res.Data.rows;
        } else {
          this.tableNeedData = [];
        }
      });

      PopularsciencePepole({
        PageIndex: 1,
        PageSize: 8,
        total: 0,
        search: "",
      }).then((res) => {
        if (res.Code === 200) {
          this.tableSienceData = res.Data;
        } else {
          this.tableSienceData = [];
        }
      });

      getList({
        PageIndex: 1,
        PageSize: 7,
        total: 0,
        parentID: "",
        key: "",
        type: "",
      }).then((res) => {
        if (res.Code === 200) {
          this.tableKnowledgeData = res.Data.rows;
        } else {
          this.tableKnowledgeData = [];
        }
      });
    },
    FormatDate(date, type) {
      if (date != null) {
        if (type == "D") {
          return date.split(" ")[0].split("/")[2];
        }
        if (type == "NY") {
          var nyr = date.split(" ")[0].split("/");
          return nyr[0] + "." + nyr[1];
        }
      }
    },
    openNewWeb(title) {
      // switch (title) {
      //   case "煤质":
      //     this.$router.push({
      //       path: "/GeologicalReport/AuxiliaryEstablishmentList",
      //       query: {
      //         title: title,
      //       },
      //     });
      //     break;
      //   default:
      //     this.$router.push({
      //       path: "/Comingsoon",
      //     });
      //     break;
      // }
    },
  },
};
</script>
<style lang="scss" scoped>
.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-bottom: 0.5rem;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.2;
  color: inherit;
}

.cont {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
}

.home-session-title {
  padding-top: 20px;
  font-size: 20px;
  font-weight: bold;
}
.home-session-title-en {
  color: #888;
  font-size: 14px;
  margin-bottom: 12px;
}
.home-session-title-dec {
  font-size: 16px;
  color: #323232;
  line-height: 1.6;
  margin-bottom: 12px;
}
.dztzcx-box {
  position: relative;
  margin: 20px 0 30px;
}
.dztzcx-box-inner {
  width: 250px;
  height: 250px;
  position: relative;
  margin: 0 auto;
  border: 1px solid #07b4e9;
  border-radius: 100%;
}
.dztzcx-image1 {
  width: 100%;
  height: 100%;
  -webkit-animation: ripple 2s ease-out infinite;
  animation: ripple 2s ease-out infinite;
}
.dztzcx-image2 {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  -webkit-animation: cromate 50s ease-out infinite;
  animation: cromate 50s ease-out infinite;
}
</style>
<style lang="scss" scoped>
.banner-image {
  width: 100%;
}
.banner-text-box {
  position: absolute;
  top: 30%;
  left: 5%;
  transform: scale(0.3);
  transform-origin: top left;
  width: 300%;
  line-height: 2;
  &.banner3 {
    text-align: center;
  }
  &.banner4 {
    text-align: right;
  }
  div {
    font-size: 45px;
    font-size: 10vw;
    color: #fff;
    white-space: nowrap;
    font-weight: 700;
  }
  p {
    font-size: 18px;
    font-size: 5vw;
    color: #fff;
    white-space: nowrap;
    font-weight: 500;
  }
  h3 {
    font-size: 25px;
    font-size: 6vw;
    color: #fff;
    white-space: nowrap;
    font-weight: 500;
  }
}
</style>
<style>
@keyframes cromate {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}
</style>
<style lang="scss" scoped>
.carousel-control-next-icon,
.carousel-control-prev-icon {
  width: 40px;
  height: 40px;
}

.border-b {
  border-bottom: 1px solid #eee;
}

.item-flex-left {
  flex-shrink: 0;
  width: 500px;
  padding: 10px;
  position: relative;
  z-index: 2;

  .item-flex-left-content {
    margin: 40px auto;
    width: 400px;
    height: 400px;

    .item-flex-left-cricle {
      width: 100%;
      height: 100%;
      position: relative;
      border: 1px solid #07b4e9;
      border-radius: 100%;

      .service-center {
        width: 100%;
        height: 100%;
        animation: ripple 2s ease-out infinite;
      }

      .service-center2 {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        animation: cromate 50s ease-out infinite;
      }
    }
  }
}

.item-flex-right {
  display: block;
  flex: 1;
  flex-basis: auto;
  padding: 10px;
}

.flex-item-ul {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  li {
    position: absolute;
    left: calc(50% - 20px);
    top: -20px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #07b4e9;
    border-radius: 100%;
    transform-origin: 20px 142px;
    cursor: pointer;

    div {
      width: 100%;
      height: 100%;
      position: relative;

      i {
        font-size: 18px;
        color: #fff;
        animation: xpf 2s ease-out infinite;
        // font-weight: bold;
        // vertical-align: middle;
      }
    }

    .flex-item-des {
      position: absolute;
      transform-origin: top left;
      left: 0;
      top: 0;
      width: 200px;
      padding: 6px 10px;
      border-radius: 4px;
      background: #07b4e9;
      text-align: left;
      color: #fff;
      height: auto;
      width: 200px;
      overflow: hidden;
      display: none;

      // transition: all 0.5s ease;
      p {
        color: #fff;
      }

      p:nth-child(1) {
        font-size: 14px;
      }

      p:nth-child(2) {
        font-size: 12px;
        line-height: 1.2;
      }
    }
  }

  @for $i from 1 through 5 {
    li:nth-of-type(#{$i}) {
      transform: rotate(($i - 1) * 72 + deg);

      .flex-item-des {
        transform: rotate(($i - 1) * -72 + deg);
      }
    }
  }

  li:nth-child(1) {
    .flex-item-des {
      left: 50px;
      top: 10px;
    }
  }

  li:nth-child(2) {
    .flex-item-des {
      left: 30px;
      top: -10px;
    }
  }

  li:nth-child(5) {
    .flex-item-des {
      left: 90px;
      top: 20px;
    }
  }
}

.flex-item-ul li:hover .flex-item-des {
  // display: block;
  // animation: hideIndex 0.5s;
}

@keyframes xpf {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.6;
  }

  100% {
    opacity: 1;
  }
}

@keyframes hideIndex {
  0% {
    opacity: 0;
    height: 0;
    // transform: translate(800px, 0);
  }

  100% {
    opacity: 1;
    height: auto;
    // transform: translate(0, 0);
  }
}

.item-flex-right-content {
  display: flex;
  flex-wrap: wrap;
}

/* Aylen */
.button.button--aylen {
  background: #fff;
  color: #37474f;
  overflow: hidden;
  -webkit-transition: color 0.3s;
  transition: color 0.3s;
  position: relative;
}

.button--aylen.button--inverted {
  background: none;
  color: #fff;
}
.button--aylen::before,
.button--aylen::after {
  content: "";
  position: absolute;
  height: 100%;
  width: 100%;
  bottom: 100%;
  left: 0;
  z-index: -1;
  -webkit-transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  -webkit-transition-timing-function: cubic-bezier(0.75, 0, 0.125, 1);
  transition-timing-function: cubic-bezier(0.75, 0, 0.125, 1);
}

.button--aylen::before {
  background: var(--styleColor);
}

.button--aylen::after {
  background: var(--styleColor);
}

.button--aylen:hover {
  color: #fff;

  p {
    color: #fff;
    i {
      color: #fff !important;
    }
  }
}

.button--aylen:hover::before,
.button--aylen:hover::after {
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
}

.button--aylen:hover::after {
  -webkit-transition-delay: 0.175s;
  transition-delay: 0.175s;
}

.item-flex-right-btn {
  width: 50%;
  overflow: hidden;

  a {
    display: block;
    margin: 6px;
    padding: 1em 2em;
    color: inherit;
    position: relative;
    z-index: 1;
    -webkit-backface-visibility: hidden;
    -moz-osx-font-smoothing: grayscale;
    border: solid 1px #e6e6e6;
    border-radius: 5px;
    box-shadow: 0 12px 5px -10px rgba(0, 0, 0, 0.1),
      0 0 4px 0 rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: 0 12px 5px -10px rgba(0, 0, 0, 0.1),
      0 0 4px 0 rgba(0, 0, 0, 0.1);

    p {
      text-align: center;
      margin-bottom: 0.3em;

      i {
        font-size: 20px;
        color: #be4949;
      }
    }
    p:last-child {
      margin-bottom: 0;
    }
  }
}
.get-more-info-btn {
  color: #fff;
  padding: 5px 30px;
  border-radius: 50px;
  font-size: 16px;
}

.manageDom {
  background: rgba(255, 255, 255, 0.1);
  // box-shadow: 0 1px 4px 0 rgba(0 0 0 / 30%);
}
.manageDom .heading {
  text-align: left;
}
.manageDom .top-line {
  width: 20%;
  margin-bottom: 15px;
  border-radius: 5px;
}

.manageDom p {
  height: 3.5rem;
  position: relative;
  margin: 10px 0px;
  overflow: hidden;
}
.manageDom a,
.surveyDom a {
  width: 100%;
  height: 3.5rem;
  overflow: hidden;
  color: #37474f;
  text-align: center;
  line-height: 3.5rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 5px;
  box-shadow: 0 12px 5px -10px rgba(0, 0, 0, 0.1), 0 0 4px 0 rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0 12px 5px -10px rgba(0, 0, 0, 0.1),
    0 0 4px 0 rgba(0, 0, 0, 0.1);
  font-size: 16px;
  -webkit-transition: color 0.3s;
  transition: color 0.3s;
  display: block;
  z-index: 1;
}
.manageDom a::before,
.manageDom a::after,
.surveyDom a::before,
.surveyDom a::after {
  content: "";
  position: absolute;
  height: 100%;
  width: 100%;
  bottom: 100%;
  overflow: hidden;
  border-radius: 5px;
  left: 0;
  z-index: -1;
  -webkit-transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  -webkit-transition-timing-function: cubic-bezier(0.75, 0, 0.125, 1);
  transition-timing-function: cubic-bezier(0.75, 0, 0.125, 1);
}

.manageDom a::before,
.surveyDom a::before {
  background: var(--styleColor);
  // background: rgba(174, 28, 28, 0.5);
}

.manageDom a::after,
.surveyDom a::after {
  background: var(--styleColor);
  // background: rgba(174, 28, 28, 0.8);
}

.manageDom a:hover,
.surveyDom a:hover {
  color: #fff;
  background: none;
}

.manageDom a:hover::before,
.manageDom a:hover::after,
.surveyDom a:hover::before,
.surveyDom a:hover::after {
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
}

.manageDom a:hover::after,
.surveyDom a:hover::after {
  -webkit-transition-delay: 0.175s;
  transition-delay: 0.175s;
}

.surveyDom {
  width: 50%;
  position: relative;
  margin: 0 !important;
  overflow: hidden;
  padding-right: 12px;
  padding-bottom: 12px;
}

.pubTit {
  text-align: center;
  font-size: 0px;
  padding-bottom: 30px;
}
.pubTit h2 {
  font-size: 20px;
  color: #333;
  font-weight: bold;
}
.pubTit p {
  font-size: 12px;
  color: #888;
  text-transform: uppercase;
  padding: 5px 0 0 0;
  margin-bottom: 5px;
}
.pubTit i {
  width: 70px;
  height: 2px;
  background: #555;
  display: inline-block;
}
.pubMore {
  width: 130px;
  height: 32px;
  display: block;
  margin: 0 auto;
  border: 1px solid #333;
  color: #333;
  border-radius: 30px;
  font-size: 14px;
  text-align: center;
  line-height: 34px;
  transition: 0.5s;
}
.pubMore:hover {
  border-color: #009ee7;
  background: #009ee7;
  color: #fff;
}

.computer {
  background: url(../../assets/img/bg3.png) center bottom no-repeat;
  background-size: cover;
  padding: 20px 0 50px;
  position: relative;
}

.computer .img-sec img {
  margin-left: 10px;
  padding-bottom: 80px;
}
.computer .btn {
  border-radius: 50px;
  padding: 5px 50px;
}
.computer .buttons {
  margin: 8% 0 0 38%;
}
.ball_a {
  display: block;
  width: 64px;
  height: 64px;
  overflow: hidden;
  background: url(../../assets/img/float_icon_a.png) no-repeat center center;
  background-size: contain;
  position: absolute;
  top: 3%;
  right: 0;
  bottom: auto;
  left: auto;
}

.ball_b {
  display: block;
  width: 100px;
  height: 100px;
  background: url(../../assets/img/float_icon_b.png) no-repeat center center;
  background-size: contain;
  position: absolute;
  bottom: -40px;
  left: 0px;
  top: auto;
  right: auto;
}

.ball_c {
  display: block;
  width: 60px;
  height: 60px;
  background: url(../../assets/img/float_icon_c.png) no-repeat center center;
  background-size: contain;
  position: absolute;
  bottom: 0;
  right: 10px;
  top: auto;
  left: auto;
}
.ball_d {
  display: block;
  width: 100px;
  height: 100px;
  background: url(../../assets/img/float_icon_c.png) no-repeat center center;
  background-size: contain;
  position: absolute;
  bottom: 47%;
  right: -42px;
  top: auto;
  left: auto;
}
</style>
<style>
/*---- Services ----*/

.services {
  position: relative;
  overflow: hidden;
  padding: 30px 0 30px 0;
  background: url(../../assets/img/bg2.jpg) no-repeat center center;
}

.services .service-slider .owl-stage-outer {
  padding-bottom: 50px;
}

.services .item {
  padding-right: 20px;
  border: solid 1px #e6e6e6;
  transition: all 0.5s ease-in-out;
  padding: 25px;
  background: #fff;
  margin: 0 12px;
}

.services .item i {
  display: block;
}

.services .item i::before {
  font-size: 50px;
  line-height: 60px;
  transition: all 0.5s ease-in-out;
}

.services .item:hover i::before {
  color: #fff !important;
}

.services .item > a {
  display: block;
}
.services .item h5 {
  text-align: center;
  font-weight: 600;
  line-height: 40px;
  margin-bottom: 0;
  color: #262626;
}

.services .item h5 a {
  display: inline-block;
  transition: all 0.5s ease-in-out;
}
.services .item h5 {
  transition: all 0.5s ease-in-out;
}

.services .item p {
  padding-bottom: 0px;
  font-size: 14px;
  transition: all 0.5s ease-in-out;
  margin-bottom: 0;
  color: #333;
}

.services .item .service_icon {
  display: block;
  overflow: hidden;
}
.services .item:hover p,
.services .item:hover h5 a,
.services .item:hover h5 {
  color: #fff !important;
}

.xwcb {
  width: 100%;
  background-color: #fff;
  padding: 20px 12px;
  margin-top: 5px;
  box-shadow: 0 0 30px -2px #e4eafc;
  transition: all ease 0.3s;
}
.xwcb > a {
  display: flex;
  align-items: center;
}
.xwcb_a {
  width: 60px;
  height: 60px;
  border: 1px solid #bfbfbf;
  text-align: center;
  font-size: 13px;
  color: #8a8a8a;
  padding-top: 5px;
  transition: all ease 0.3s;
  line-height: 1;
}
.xwcb_a span {
  font-size: 32px;
  color: #8a8a8a;
  display: block;
  line-height: 30px;
  margin-bottom: 4px;
  transition: all ease 0.3s;
}
.xwcb_b {
  flex: 1;
  overflow: hidden;
  margin-left: 8px;
  font-family: "微软雅黑";
}
.xwcb_b h6 {
  font-size: 16px;
  color: #282828;
  font-weight: 700;
  line-height: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: all ease 0.3s;
  margin-bottom: 0;
}
.xwcb_b p {
  font-size: 13px;
  color: #686868;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 3px;
  margin-bottom: 0;
  padding-bottom: 0;
}
.xwcb_c {
  width: 25px;
  height: 25px;
  overflow: hidden;
  position: relative;
  display: none;
}
.xwcb_c img {
  width: 100%;
}
.xwcb_c img:nth-child(2) {
  position: absolute;
  left: 0;
  bottom: -47px;
  transition: all ease 0.3s;
  width: 100%;
}
.xwcb_c img:nth-child(1) {
  opacity: 1;
  transition: all ease 0.3s;
  position: absolute;
  left: 0;
  top: 0px;
  width: 100%;
}
.xwcb:hover .xwcb_a {
  border-color: #1c86f2;
  color: #1c86f2;
}
.xwcb:hover .xwcb_a span {
  color: #1c86f2;
}
.xwcb:hover .xwcb_b h6 {
  font-weight: bold;
}
.xwcb:hover .xwcb_c img:nth-child(2) {
  bottom: 0;
}
.xwcb:hover .xwcb_c img:nth-child(1) {
  opacity: 0;
  top: -47px;
}
.xwcb:hover {
  transform: translateY(-5px);
}

.news-tab-nav {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5%;
}
.news-tab-nav span {
  display: block;
  border-bottom: 2px solid #00509b;
  width: 22%;
  height: 35px;
  line-height: 35px;
  text-align: center;
  color: #666;
  cursor: default;
}
.news-tab-nav span:last-child {
  margin-right: 0;
}
.news-tab-nav span.active {
  background: #00509b;
  color: #fff;
}
.home-news-date {
  background: #00509b;
  color: #fff;
  width: 61px;
  height: 61px;
  padding: 12px;
  text-align: center;
  box-sizing: content-box;
}
.home-news-date span {
  color: #f27b16;
  font: bold 30px/30px "novecento" !important;
  display: block;
  margin-bottom: 3px;
}
.home-news-content h6 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #666;
  font-size: 16px;
  margin-bottom: 5px;
  padding-top: 5px;
}
.home-news-content p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #666;
  font-size: 16px;
  margin-bottom: 3px;
}
.home-news-more {
  text-align: right;
  color: #666;
  font-size: 14px;
}
.home-news-right {
  flex: 1;
  padding: 0 15px;
  overflow: hidden;
}
.home-news-right:hover {
  background: #00509b;
}
.home-news-right:hover .home-news-content p,
.home-news-right:hover .home-news-content h6,
.home-news-right:hover .home-news-more {
  color: #fff;
}
.home-news-item {
  padding: 5px 0 5px;
  border-bottom: 1px solid #cdcdcd;
  font-family: "微软雅黑";
  margin-bottom: 1%;
}

.home-news-list {
}
.home-video-center {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  justify-content: space-between;
  padding-top: 20px;
}
.home-video-center h6 {
  font-size: 20px;
  color: #004e97;
  color: #222;
  font-weight: bold;
  line-height: 1;
}
.home-video-center span {
  font-size: 14px;
  color: #004e97;
  color: #666;
  cursor: pointer;
  line-height: 1;
}
.home-video-center span:hover {
  opacity: 0.8;
}
.video-banner {
  /* background:url(../../img/home-video-bg.png) no-repeat center; */
  background-size: 100% 100%;
  padding-top: 0;
}
.home-video-people {
  line-height: 3;
  background: #ccc;
  text-align: center;
  font-size: 16px;
  height: auto;
}
.home-video-people a {
  cursor: pointer;
  color: #323232;
  font-size: 18px;
}
.home-video-people a:hover {
  text-decoration: underline !important;
  color: #007bff;
}
.home-qr-code-box {
  position: absolute;
  right: 0;
  width: 10vw;
  top: 0;
}
.home-qr-code-inner {
  display: none;
  text-align: center;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 12px;
}
.home-qr-code-box:hover .home-qr-code-inner {
  display: block;
}
.home-yszt-tips {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  line-height: 3;
  padding: 0 12px;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  font-size: 14px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.flex1 {
  display: flex;
}
</style>




// WEBPACK FOOTER //
// src/views/home/Index_h5.vue